document.addEventListener("DOMContentLoaded", function () {
  const splideEl = document.querySelector(".lighting-splide-container");
  if (!splideEl) return;

  const rightItems = document.querySelectorAll(".lighting-collection-categories li");

  function setActive(index) {
    rightItems.forEach((item) => item.classList.remove("active"));
    if (rightItems[index]) {
      rightItems[index].classList.add("active");
    }
  }

  // Handle Splide initialization and updates
  if (splideEl.splide) {
    const initialIndex = splideEl.splide.index || 0;
    setActive(initialIndex);

    splideEl.splide.on("move", (newIndex) => {
      setActive(newIndex);
    });
  } else {
    // Fallback if component initialises later
    splideEl.addEventListener("splide:mounted", () => {
      setActive(splideEl.splide.index || 0);
    });
  }

  // Add click listener to right-hand category cards to switch Splide slides
  rightItems.forEach((item, index) => {
    item.addEventListener("click", function (e) {
      if (splideEl.splide) {
        splideEl.splide.go(index);
      }
    });
  });
});